import type { PropsWithChildren, ReactNode } from 'react';

type PageShellProps = PropsWithChildren<{
  title: string;
  eyebrow?: string;
  action?: ReactNode;
}>;

export function PageShell({ title, eyebrow = '课件互动练习', action, children }: PageShellProps) {
  return (
    <main className="page-shell">
      <header className="topbar">
        <div>
          <span>{eyebrow}</span>
          <strong>{title}</strong>
        </div>
        {action}
      </header>
      <section className="content-card">{children}</section>
      <footer>课件互动练习 · 手机号登录后继续学习</footer>
    </main>
  );
}

